
export interface CreateSubscriptionResult {
    name: string;
    raftCommandIndex?: number;
}
